import { useState } from "react";
import QrCodeDialog from "./QrCodeDialog.tsx";
import LaunchingAppDialog from "../../layout/sidebar/my-account/read-offline/LaunchingAppDialog.tsx";

export default function QrCodeDialogSwitcher({
  onRequestClose,
}: {
  onRequestClose: () => void;
}) {
  const [activeDialog, setActiveDialog] = useState<"qr-code" | "download-app">(
    "qr-code"
  );
  const [downloadUrl, setDownloadUrl] = useState<string>("");

  if (activeDialog == "qr-code") {
    return (
      <QrCodeDialog
        onRequestClose={onRequestClose}
        onOpenAppDialog={(url: string) => {
          setDownloadUrl(url);
          setActiveDialog("download-app");
        }}
      />
    );
  }
  if (activeDialog == "download-app") {
    return (
      <LaunchingAppDialog
        onRequestClose={onRequestClose}
        designatedDownloadAppUrl={downloadUrl}
      />
    );
  }
}
